// Non-cryptographic 32-bit hash. Used as a token fingerprint so we can
// disambiguate cross-tab writes without ever exporting the token itself.
function fnv1a(input: string): string {
  let hash = 0x811c9dc5
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i)
    hash = Math.imul(hash, 0x01000193)
  }
  return (hash >>> 0).toString(16).padStart(8, '0')
}

function decodeJwtExp(token: string): number | undefined {
  const parts = token.split('.')
  if (parts.length < 2) return undefined
  try {
    const padded = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const decoded = atob(padded + '==='.slice((padded.length + 3) % 4))
    const payload = JSON.parse(decoded)
    return typeof payload?.exp === 'number' ? payload.exp : undefined
  } catch {
    return undefined
  }
}

export type TokenSummary = {
  fp: string
  exp?: number
  ttlSec?: number
}

export function summarizeToken(
  token: string | null | undefined
): TokenSummary | undefined {
  if (!token || typeof token !== 'string') return undefined
  const exp = decodeJwtExp(token)
  const nowSec = Math.floor(Date.now() / 1000)
  return {
    fp: fnv1a(token),
    exp,
    ttlSec: exp != null ? exp - nowSec : undefined
  }
}

export type UserStorageSummary = {
  access?: TokenSummary
  refresh?: TokenSummary
  userId?: number
  isLoggedIn?: boolean
  isAnonymous?: boolean
}

export function summarizeUserStorageValue(
  raw: string | null | undefined
): UserStorageSummary | undefined {
  if (!raw || raw === '[REDACTED]') return undefined
  try {
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return undefined
    return {
      access: summarizeToken(parsed.access_token),
      refresh: summarizeToken(parsed.refresh_token),
      userId: typeof parsed.id === 'number' ? parsed.id : undefined,
      isLoggedIn:
        typeof parsed.isLoggedIn === 'boolean' ? parsed.isLoggedIn : undefined,
      isAnonymous: parsed.role === 'anonymous' ? true : undefined
    }
  } catch {
    return undefined
  }
}
